import './App.css';
import {
  BrowserRouter,
  Switch,
  Route,
} from "react-router-dom";
import AppLayout from './layouts/app-layout';
import { ConfirmProvider } from 'material-ui-confirm';

export default function App() {
  return (
    <BrowserRouter>
      <Switch>
        <ConfirmProvider>
          <Route path="/" component={AppLayout} />
        </ConfirmProvider>
      </Switch>
    </BrowserRouter>
  );
}